
















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { sendBuddyResponse } from '@/api/buddy-api';
import { IBuddyStatus } from '@/interfaces/buddy-status.interface';
import VEmojiPicker from 'v-emoji-picker';
import miscTypes from '../vuex/misc/types';

@Component({
    props: {
        buddyCode: String,
        buddyStatus: String
    },
    components: {
        VEmojiPicker
    }
})
export default class BuddyResponse extends Vue {
    buddyStatusObj: IBuddyStatus = {
        name: '',
        message: '',
        mood: '',
        usedPainkillers: false
    };
    reply = '';
    buttonDisabled = false;
    apiCallDone = false;
    succesfull = false;
    error = false;
    showEmoji = false;

    mounted(): void {
        if (this.$props.buddyCode === '') {
            this.$router.push({ name: '403' });
            return;
        }

        if (this.$props.buddyStatus) {
            try {       
                this.buddyStatusObj = Object.assign(
                    {},
                    JSON.parse(
                        window.atob(this.$props.buddyStatus)
                    )
                );
            } catch (e) {
                this.$router.push({ name: '500' });
            }
        }
    }

    addEmoji(emoji: any): void {
        this.focusTextInput();
        this.reply += emoji.data;
    }

    toggleEmojis(): void {
        this.focusTextInput();
        this.showEmoji = !this.showEmoji;
    }

    focusTextInput(): void {
        (this.$refs.textInput as HTMLElement).focus();
    }

    submit(): void {
        this.$store.dispatch(miscTypes.actions.TOGGLE_LOADER);
        this.buttonDisabled = true;
        sendBuddyResponse(this.reply, this.$props.buddyCode).then(() => {
            this.succesfull = true;
        })
        .catch(() => {
            this.error = true;
        })
        .finally(() => {
            this.apiCallDone = true;
            this.buttonDisabled = false;
            this.$store.dispatch(miscTypes.actions.TOGGLE_LOADER);
        });
    }

}
